import React, { useEffect, useState } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { reduxForm, getFormValues, isInvalid, Field } from 'redux-form';

import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

import { DELETE, GET_ONE, UPDATE, provider, history, confirm } from '../../_utils';
import KnowledgeBase from './KnowledgeBase';
import '../scripts.css';
import '../../operators/operators.css';

import {
    SaveButton,
    CloseButton,
    Modal,
    TextInput,
    PageHeader,
    SaveStatus,
    StatusChip,
    LoadingStub,
} from '../../_Components';

const articleWord = (n) => {
    const m = n % 100;
    const d = n % 10;
    if (m > 10 && m < 20) return 'статей';
    if (d === 1) return 'статья';
    if (d >= 2 && d <= 4) return 'статьи';
    return 'статей';
};

const countArticles = (script) => {
    if (!script) return 0;
    const pages = script.pages ? script.pages.length : 0;
    const cats = (script.categories || []).reduce((sum, cat) => sum + ((cat.articles && cat.articles.length) || 0), 0);
    return pages + cats;
};

const ScriptEdit = ({ match, initialize, initialized, formValues, invalid, isSaving, change, dirty }) => {
    const [edit, setEdit] = useState(false);
    const [mode, setMode] = useState('read');
    const [menuEl, setMenuEl] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            const { data } = await provider(
                GET_ONE,
                '/scripts',
                match.params.id
            );
            initialize(data);
        };

        if (!initialized) {
            fetchData();
        }
    }, [match, initialize, initialized]);

    const save = async () => {
        if (!formValues) return;
        const { data } = await provider(UPDATE, '/scripts/', { id: formValues._id, data: formValues });
        initialize(data);
    };

    const editName = () => {
        setMenuEl(null);
        setEdit(!edit);
    };

    const saveEdit = ({ name }) => {
        change('name', name);
        setEdit(false);
    };

    const close = () => {
        history.push('/scripts');
    };

    const deleteScript = () => {
        setMenuEl(null);
        confirm({
            title: 'Удалить скрипт?',
            message: 'Вы уверены, что хотите удалить скрипт?',
            confirmLabel: 'Удалить',
            onConfirm: () => {
                provider(DELETE, '/scripts/', match.params.id);
                close();
                history.push('/scripts');
            }
        });
    };

    const total = countArticles(formValues);

    return (
        <div className="pc-page pc-kb">
            <PageHeader
                leading={(
                    <button type="button" className="pc-emp-btn" onClick={close}>
                        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.7">
                            <path d="M13 8H4M7.5 4.5L4 8l3.5 3.5" />
                        </svg>
                        Все скрипты
                    </button>
                )}
                title={(formValues && formValues.name) || 'Скрипт'}
                chips={(
                    <StatusChip tone="mono">
                        {total} {articleWord(total)}
                    </StatusChip>
                )}
                actions={(
                    <>
                        <div className="pc-kb-seg" role="tablist">
                            <button
                                type="button"
                                role="tab"
                                aria-selected={mode === 'read'}
                                onClick={() => setMode('read')}
                            >
                                <VisibilityOutlinedIcon sx={{ fontSize: 12 }} />
                                Как видит оператор
                            </button>
                            <button
                                type="button"
                                role="tab"
                                aria-selected={mode === 'edit'}
                                onClick={() => setMode('edit')}
                            >
                                <EditOutlinedIcon sx={{ fontSize: 12 }} />
                                Редактирование
                            </button>
                        </div>
                        <SaveStatus dirty={!!dirty} />
                        <SaveButton
                            isSaving={isSaving || invalid}
                            handleSaveClick={save}
                            disabled={!formValues}
                        />
                        <IconButton
                            size="small"
                            onClick={(e) => setMenuEl(e.currentTarget)}
                            title="Ещё"
                            disabled={!formValues}
                        >
                            <MoreVertIcon fontSize="small" />
                        </IconButton>
                        <Menu
                            anchorEl={menuEl}
                            open={Boolean(menuEl)}
                            onClose={() => setMenuEl(null)}
                        >
                            <MenuItem onClick={editName} disabled={!formValues}>Переименовать</MenuItem>
                            <MenuItem onClick={deleteScript}>Удалить</MenuItem>
                        </Menu>
                        <CloseButton isSaving={isSaving} handleCloseClick={close} />
                    </>
                )}
            />
            {formValues
                ? <KnowledgeBase save={save} mode={mode} />
                : (
                    <div className="pc-kb-stage">
                        <LoadingStub title="Открываем скрипт" />
                    </div>
                )
            }
            {edit && (
                <Modal
                    title="Переименовать"
                    open={edit}
                    handleSaveClick={saveEdit}
                    handleCloseClick={editName}
                    initial={{ name: formValues.name }}
                    fields={<Field name="name" component={TextInput} />}
                />
            )}
        </div>
    );
};

const mapStateToProps = (state) => {
    const formValues = getFormValues('script')(state);
    const { fetch } = state;
    return {
        formValues,
        isSaving: fetch ? (fetch.creat > 0) : false,
        invalid: isInvalid('script')(state),
    };
};

const enhance = compose(
    connect(mapStateToProps),
    reduxForm({
        form: 'script',
    })
);

export default enhance(ScriptEdit);
